import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Gear } from '@phosphor-icons/react'
import { isSystemActor } from './rbacAuditHistoryHelpers'
import {
  auditActorPrimarySx,
  auditActorSecondarySx,
  auditSystemBadgeSx
} from './rbacAuditHistoryConstants'

export default function RbacAuditActorCell({ entry }) {
  if (isSystemActor(entry)) {
    return (
      <Box component="span" sx={auditSystemBadgeSx}>
        <Gear size={14} weight="regular" />
        Sistema
      </Box>
    )
  }

  const primary = entry.actor_name || entry.actor_email || '—'
  const secondary = entry.actor_name ? entry.actor_email : ''

  return (
    <Box>
      <Typography sx={auditActorPrimarySx}>{primary}</Typography>
      {secondary ? <Typography sx={auditActorSecondarySx}>{secondary}</Typography> : null}
    </Box>
  )
}
